// extracted by mini-css-extract-plugin
export default {"banner":"AppStore--banner--494e4f","appStoreButtons":"AppStore--appStoreButtons--aa036e"};